import React from "react";
import { Paper, Button, Typography, Box, CircularProgress } from "@mui/material";
import { TextCopyIcons } from "../../../components/Icons";
import image from "../../../assets/images/ReferEarn.png";
import steps from "../../../assets/images/refereanSteps.png";
import classes from "./ReferEarn.module.css";
import copy from "copy-to-clipboard";
import { useState } from "react";
import ReferHistoryModal from "./ReferHistoryModal";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { GET_USER } from "../../../api-calls/api-urls";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import AlertBox from "../../../components/AlertBox";

const Referearn = () => {
  const dispatch = useDispatch();
  const [loggedUser, setLoggedUser] = useState();
  const userInfoStr = sessionStorage.getItem("userInfo");
  const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
  const [modalToggle, setModalToggle] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState();
  const ln = useSelector((state) => state.allUsers.language_json);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const modalClose = () => {
    setModalToggle(false);
  };

  const copyTrst = (text) => {
    copy(text);
    setShowAlert(true);
    setError("Code has Copied Successfully");
  };

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 2000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  const getCurrentLoggedUser = async () => {
    if (!userInfo?._id) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await authApi.get(`${GET_USER}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      console.log(data);
      setLoggedUser(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCurrentLoggedUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {loading || !loggedUser || !ln ? (
        <Box className={classes.loaderContainer} sx={{ flexDirection: 'column', gap: 2 }}>
          <CircularProgress />
          <Typography color="textSecondary">Loading referral details...</Typography>
        </Box>
      ) : (
        <Paper className={classes.ReferEarnMainPaper}>
          <Typography className={classes.ReferTextMain} sx={{ mb: 3 }}>
            {ln.earn_every_time_you_refer_someone_they_join}
          </Typography>
          <Box sx={{ mb: 3 }} className={classes.ReferEarnCopButton}>
            <Typography>{loggedUser.my_referral_code}</Typography> |{" "}
            <span onClick={() => copyTrst(loggedUser.my_referral_code)}>
              <TextCopyIcons />
            </span>
          </Box>
          <Box sx={{ mb: 3 }}>
            <img src={image} alt="" />
          </Box>
          <Typography className={classes.ReferTextSub} sx={{ mb: 6 }}>
            {ln.how_it_works}
          </Typography>
          <Box sx={{ mb: 6 }}>
            <img src={steps} alt="" />
          </Box>
          <Button
            variant="outlined"
            className={`${classes.ReferEarnMainButton}`}
            onClick={() => setModalToggle(true)}
          >
            {ln.your_referral_history}
          </Button>
        </Paper>
      )}
      {modalToggle ? <ReferHistoryModal closeModal={modalClose} /> : null}
      {showAlert && error && (
        <AlertBox type="success" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default Referearn;
